'use client';

import React from 'react';
import { Box, Link } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import DynamicScrollHeader from '@components/DynamicScrollHeader';
import DynamicLogo from '@components/DynamicLogo';
import AldarLogo from '@components/AldarLogo';
import { LanguageDropdown } from '@components/LanguageDropdown';
import DynamicHideBlock from '@components/DynamicHideBlock';
import cn from './style.module.scss';
export default function EastvaleHeader(props: MarketingPageComponentProps) {
  const headerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'header' && section.enabled
  );
  if (!headerSection) return null;
  return (
    <DynamicScrollHeader
      headerClassName={cn.eastvaleHeaderWrapper}
      scrolledClassName={cn.eastvaleHeaderScroll}
    >
      <Box className={cn.eastvaleHeaderInner}>
        <Box className={cn.eastvaleHeaderBlock}>
          <Box className={cn.eastvaleHeadeControls}>
            <Box className={cn.eastvaleHeaderSodic}>
              <DynamicLogo
                logoImage={headerSection?.eastvaleHeadrLogo}
                alt="Eastvale Sodic Logo"
              />
            </Box>
            <DynamicHideBlock data={headerSection?.eastvaleHeadrLanguage}>
              <Box className={cn.eastvaleHeaderDropdown}>
                <LanguageDropdown
                  className={cn.eastvaletNavLanguage}
                  options={props.langOptions || []}
                />
              </Box>
            </DynamicHideBlock>
          </Box>
          <Box className={cn.eastvaleHeaderBrand}>
            <Link
              className={cn.eastvaleBrandElement}
              href="https://www.aldar.com/properties/en"
              target="_blank" rel="noopener noreferrer"
            >
              <AldarLogo color="white" />
            </Link>
          </Box>
        </Box>
      </Box>
    </DynamicScrollHeader>
  );
}
